__turbopack_context__.v({
  "checkout": "CartRail-module-scss-module__lb66ra__checkout",
  "expand": "CartRail-module-scss-module__lb66ra__expand",
  "itemAdded": "CartRail-module-scss-module__lb66ra__itemAdded",
  "rail": "CartRail-module-scss-module__lb66ra__rail",
  "small": "CartRail-module-scss-module__lb66ra__small",
  "status": "CartRail-module-scss-module__lb66ra__status",
  "summary": "CartRail-module-scss-module__lb66ra__summary",
});
